import { render, staticRenderFns } from "./classifySearch.vue?vue&type=template&id=794b1cec&scoped=true"
import script from "./classifySearch.vue?vue&type=script&lang=js"
export * from "./classifySearch.vue?vue&type=script&lang=js"
import style0 from "./classifySearch.vue?vue&type=style&index=0&id=794b1cec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794b1cec",
  null
  
)

export default component.exports